import { Flex, Heading, Icon, Text } from '@everlywell/ui-kit';
import { MapPinLine } from '@phosphor-icons/react';
import React from 'react';
import { QuestLocation } from 'utils/api/questApis';

export type QuestLocationCardProps = {
  /** This is the text that is displayed in the component*/
  location: QuestLocation;
};

/**
 * [Add the description for what this component does here].
 */
const QuestLocationCard = ({ location }: QuestLocationCardProps) => (
  <Flex
    flexDirection={'column'}
    alignItems={'flex-start'}
    backgroundColor={'tints.white'}
    borderRadius={'12px'}
    paddingX={4}
    paddingY={6}
    justifyContent={'space-between'}
    gap={8}
    aria-label={`Quest Diagnostics location at ${location.address}`}
    role="section"
  >
    <Icon as={MapPinLine} color="viridian.base" />
    <Flex flexDirection={'column'} gap={4}>
      <Heading size={'xl'}>Quest Diagnostics</Heading>
      <Text size={'md'} color={'tints.darkGrey'}>
        {location.address}, {location.city}, {location.state}{' '}
        {location.zip_code.split('-')[0]}
      </Text>
    </Flex>
    <Flex
      flexDirection={'row'}
      borderTopColor={'tints.darkCream'}
      borderTopWidth={'1px'}
      borderTopStyle={'solid'}
      width={'100%'}
      paddingTop={4}
      justifyContent={'space-between'}
    >
      <Text>{location.hours}</Text>
      <Flex flexDirection={'column'}>
        <Text size="lg" fontWeight={'medium'}>
          {location.distance.toFixed(1)} mi
        </Text>
        <Text size="md" color={'tints.uiGrey'}>
          Away
        </Text>
      </Flex>
    </Flex>
  </Flex>
);

export default QuestLocationCard;
